import {configureStore} from '@reduxjs/toolkit'
import allProspectsCountSliceReducer from './prospectSegment/allProspectsCount/allProspectsCountSlice'
import selectedProspectsTabSlice from './prospectSegment/selectedProspectsTab/selectedProspectsTabSlice'
import pageNumberSlice from './pagination/pageNumberSlice'
import addTableColumnSlice from './prospectSegment/addTableColumn/addTableColumnSlice'
import saveProspectsListSlice from './prospectSegment/savedProspectsList/saveProspectsListSlice'
import userProfileSlice from './userProfile/userProfileSlice'
import actionMenuSlice from './prospectSegment/selectedActionMenu/actionMenuSlice'
import allProspectsDataSlice from './prospectSegment/allProspectsData/allProspectsDataSlice'
import opportunityBankSlice from './opportunityBank/opportunityBankSlice'
import attendeeSectionSlice from './opportunityBank/attendeeSectionSlice'
import searchSlice from './search/searchSlice'
import campaignViewSlice from './selectedView/campaignView/campaignViewIndex'
import addToSavedProspectSlice from './prospectSegment/addToSavedProspects/addToSavedProspectsSlice'
import campaignActionSlice from './selectedView/campaignView/campaignActionSlice'
import openSavedProspectSlice from './prospectSegment/openSavedProspect/openSavedProspectSlice'
import askGivePrismSlice from './askGivePrism/askGivePrismSlice'
import timelineChartSlice from './timelineChart/timelineChartSlice'
import categorizedInterestTagSlice from './askGivePrism/categorizedInterestTagSlice'
import idleTimeoutSlice from './idleTimeout/idleTimeoutSlice'
import chatbotStreamSlice from './askGivePrism/chatbot/chatbotStreamSlice'
import superUserSlice from './superuser/superUserSlice'
import exportListSlice from './prospectSegment/exportList/exportListSlice'

const store = configureStore({
  reducer: {
    userProfile: userProfileSlice,
    totalProspectsCount: allProspectsCountSliceReducer,
    selectedProspectTab: selectedProspectsTabSlice,
    currentPageNumber: pageNumberSlice,
    addColumnProspectsTable: addTableColumnSlice,
    saveProspectList: saveProspectsListSlice,
    selectedActionMenu: actionMenuSlice,
    getAllProspectsData: allProspectsDataSlice,
    opportunityBank: opportunityBankSlice,
    attendeeSection: attendeeSectionSlice,
    askGivePrism: askGivePrismSlice,
    search: searchSlice,
    campaignView: campaignViewSlice,
    addToSavedProspect: addToSavedProspectSlice,
    campaignAction: campaignActionSlice,
    openSavedProspect: openSavedProspectSlice,
    timelineChart: timelineChartSlice,
    categorizedInterestTag: categorizedInterestTagSlice,
    idleTimeout: idleTimeoutSlice,
    chatBotSlice: chatbotStreamSlice,
    superUserTenantSlice: superUserSlice,
    exportList: exportListSlice
  }
})

export default store
